<template>

    <div v-if="isLoading" class="loading-overlay">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
    </div>


    <div class="row">

        <div class="col-xl-12 d-flex">
            <div class="card flex-fill">
                <div class="card-header">
                    <div class="row align-center">
                        <div class="col">
                            <h5 class="card-title">Compra</h5>
                        </div>
                    </div>
                </div>
                <div class="card-body card-buttons">
                    <form class="needs-validation" novalidate>
                        <div class="row">
                            <div class="col-8 input-block">
                                <label>Documento</label>
                                <input class="form-control" type="file" @change="handleImageUpload" accept="image/*" />
                            </div>

                            <div class="col-4 input-block">
                                <label for="ncomprobante">N° Comprobante</label>
                                <b-form-input type="text" v-model="compra.ncomprobante" id="ncomprobante"
                                    class="form-control" :class="{ 'is-invalid': errors.ncomprobante }"
                                    @input="validateNcomprobante" />
                                <div class="invalid-feedback">{{ errors.ncomprobante }}</div>
                            </div>
                            <div class="col-12 mt-2 input-block">
                                <label>Proveedor</label>
                                <div class="col-md-12 col-sm-12">
                                    <select v-model="compra.proveedorId" class="form-control"
                                        :class="{ 'is-invalid': errors.proveedorId }" @change="validateProveedor">
                                        <option value="" disabled>Selecciona</option>
                                        <option v-for="proveedor in proveedores" :key="proveedor.id"
                                            :value="proveedor.id">
                                            {{ proveedor.tipo_rif }}-{{ proveedor.rif }} {{ proveedor.nombre }}
                                        </option>
                                    </select>

                                    <div class="invalid-feedback">{{ errors.proveedorId }}</div>
                                </div>
                            </div>


                        </div>


                    </form>
                </div>
            </div>
        </div>

        <div class="col-xl-12 d-flex">
            <div class="card super-admin-dash-card">
                <div class="card-header">
                    <div class="row align-center">
                        <div class="col">
                            <h5 class="card-title">Productos</h5>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0">
                    <div class="row">
                        <div class="col-12 mt-2 input-block">
                            <label>Productos</label>
                            <div class="col-md-12 col-sm-12">
                                <select v-model="detalle.productoId" class="form-control"
                                    :class="{ 'is-invalid': errorAgregar.productoId }" @change="selectProduct($event)">
                                    <option value="" disabled>Selecciona</option>
                                    <option v-for="product in productos" :key="product.id" :value="product.id">
                                        {{ product.titulo }}
                                    </option>
                                </select>

                                <div class="invalid-feedback">{{ errorAgregar.productoId }}</div>
                            </div>
                        </div>

                        <div class="col-6 mt-2 input-block">
                            <label>Variedad</label>
                            <div class="col-md-12 col-sm-12">
                                <select v-model="detalle.variedadId" class="form-control">
                                    <option value="" disabled>Selecciona</option>
                                    <option v-for="variedad in variedades" :key="variedad.id" :value="variedad.id">
                                        {{ variedad.talla ? 'Talla: ' + variedad.talla + ' ' : '' }}
                                        {{ variedad.medida ? 'Medida: ' + variedad.medida + ' ' : '' }}
                                        {{ variedad.color ? 'Color: ' + variedad.color : '' }}
                                    </option>
                                </select>

                            </div>
                        </div>

                        <div class="col-3 mt-2 input-block">
                            <label>Precio</label>
                            <div class="col-md-12 col-sm-12">
                                <b-form-input type="number" v-model="detalle.precio_unidad" id="precio_unidad"
                                    class="form-control" :class="{ 'is-invalid': errorAgregar.precio_unidad }"
                                    @input="validatePrecio" />
                                <div class="invalid-feedback">{{ errorAgregar.precio_unidad }}</div>
                            </div>
                        </div>

                        <div class="col-3 mt-2 input-block">
                            <label>Cantidad</label>
                            <div class="col-md-12 col-sm-12">
                                <b-form-input type="number" v-model="detalle.cantidad" id="cantidad"
                                    class="form-control" :class="{ 'is-invalid': errorAgregar.cantidad }"
                                    @input="validateCan" />
                                <div class="invalid-feedback">{{ errorAgregar.cantidad }}</div>
                            </div>
                        </div>

                        <div class="col-12 mt-3 input-block text-end">
                            <b-button @click="agregarDetalle" class="btn-primary w-100">
                                Agregar
                            </b-button>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="col-xl-12 d-flex">
            <div class="card super-admin-dash-card">
                <div class="card-header">
                    <div class="row align-center">
                        <div class="col">
                            <h5 class="card-title">Lista de Compra</h5>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0">
                    <div class="table-responsive">
                        <table class="table table-stripped table-hover">
                            <thead>
                                <tr>
                                    <th>Producto</th>
                                    <th>Variedad</th>
                                    <th class="text-end">Precio</th>
                                    <th class="text-end">Can.</th>
                                    <th class="text-end">Sub Total</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="detalle in detalles" :key="detalle.id">
                                    <td>{{ detalle.productoNombre }}</td>
                                    <td>
                                        {{ detalle.variedad?.talla ? 'Talla: ' + detalle.variedad.talla + ' ' : '' }}
                                        {{ detalle.variedad?.medida ? 'Medida: ' + detalle.variedad.medida + ' ' : '' }}
                                        {{ detalle.variedad?.color ? 'Color: ' + detalle.variedad.color : '' }}
                                    </td>
                                    <td class="text-end">{{ formatoMoneda(detalle.precio_unidad) }}</td>
                                    <td class="text-end">{{ detalle.cantidad }}</td>
                                    <td class="text-end">{{ formatoMoneda(detalle.subtotal) }}</td>
                                    <td class="text-center">
                                        <button @click="eliminarDetalle(detalle.id)"
                                            class="btn btn-sm btn-danger rounded-circle p-0"
                                            style="width: 30px; height: 30px;" title="Eliminar">
                                            <i class="fas fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="4" class="text-end fw-bold">Total:</td>
                                    <td class="fw-bold text-end">{{ formatoMoneda(calcularTotal) }}</td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-end mt-3">
            <b-button @click="processCompra" class="btn-primary m-1">
                Procesar Compra
            </b-button>
        </div>


    </div>
</template>

<script>
import api from '@/api';

export default {
    data() {
        return {
            isLoading: false,
            compra: {
                documento: '',
                ncomprobante: '',
                proveedorId: '',
            },
            errors: {
                documento: '',
                ncomprobante: '',
                proveedorId: '',
            },
            errorAgregar: {
            },
            detalle: {
                cantidad: '',
                precio_unidad: '',
                productoId: '',
                variedadId: ''
            },
            detalles: [],
            variedades: [],
            proveedores: [],
            productos: [],
            baseURL: api.defaults.baseURL,
            selectedImage: null,
        };
    },
    mounted() {
        this.loadProveedores();
        this.loadProductos();
        this.loadDetallesFromLocalStorage();
    },

    methods: {
        formatoMoneda(value) {
            if (!value) return '0,00';
            const numero = Number(value).toFixed(2);
            return numero
                .replace('.', ',')
                .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        },
        async loadProveedores() {
            try {
                const response = await api.get('/proveedor');
                this.proveedores = response.data;
            } catch (err) {
                this.error = 'Error al cargar proveedores';
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },

        async loadProductos() {
            try {
                const response = await api.get('/producto/lista_producto_activo');
                this.productos = response.data;
            } catch (err) {
                this.error = 'Error al cargar productos';
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },

        handleImageUpload(event) {
            const file = event.target.files[0];
            this.errors.documento = '';

            if (file) {

                if (file.size > 2 * 1024 * 1024) {
                    this.errors.documento = 'El documento no debe exceder los 2MB';
                    return;
                }

                this.selectedImage = file;
                const reader = new FileReader();
                reader.readAsDataURL(file);
            } else {
                this.selectedImage = null;
            }
        },

        async loadDetallesFromLocalStorage() {
            try {
                const detallesGuardados = localStorage.getItem('detallesPedido');
                if (!detallesGuardados) return;

                this.detalles = JSON.parse(detallesGuardados);
            } catch (error) {
                console.error('Error al cargar detalles:', error);
            }
        },

        async processCompra() {

            if (!this.validateForm()) {
                this.$toast.error('Por favor complete correctamente todos los campos');
                return;
            }

            const result = await this.$swal.fire({
                title: '¿Guardar Compra?',
                text: 'Se guardará una nueva Compra',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, guardar',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) return;
            this.isLoading = true;

            let total = this.detalles.reduce((sum, d) => sum + parseFloat(d.subtotal), 0);

            const formData = new FormData();

            if (this.selectedImage) {
                formData.append("documento", this.selectedImage);
            }
            formData.append("proveedorId", this.compra.proveedorId);
            formData.append("ncomprobante", this.compra.ncomprobante);
            formData.append("monto_total", total);
            formData.append("monto_resultante", total);
            const detallesParaBackend = this.detalles.map(detalle => {
                return {
                    productoId: detalle.productoId,
                    variedadId: detalle.variedadId,
                    cantidad: detalle.cantidad,
                    precio_unidad: detalle.precio_unidad
                };
            });
            formData.append("detalles", JSON.stringify(detallesParaBackend));

            try {
                const response = await api.post("/ingreso", formData);
                this.isLoading = false;
                this.$toast.success('Compra registrada con éxito');
                localStorage.removeItem('detallesPedido');
                this.detalles = [];
                this.compra = {
                    documento: '',
                    ncomprobante: '',
                    proveedorId: '',
                }
                this.selectedImage = null;


            } catch (error) {
                this.isLoading = false;
                let errorMessage = 'Error al procesar datos';

                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (error.message) {
                    errorMessage = error.message;
                }

                this.$toast.error(errorMessage);
            }
        },

        validateForm() {
            let isValid = true;

            if (!this.compra.ncomprobante) {
                this.errors.ncomprobante = 'El num. comprobante es requerido';
                isValid = false;
            } else {
                this.errors.ncomprobante = '';
            }

            if (!this.compra.proveedorId) {
                this.errors.proveedorId = 'Seleccione un Proveedor';
                isValid = false;
            } else {
                this.errors.proveedorId = '';
            }

            return isValid;
        },

        validateProveedor() {
            if (!this.compra.proveedorId) {
                this.errors.proveedorId = 'Seleccione un Proveedor';
            } else {
                this.errors.proveedorId = '';
            }
        },

        validateNcomprobante() {
            if (!this.compra.ncomprobante) {
                this.errors.ncomprobante = 'El num. comprobante es requerido';
            } else {
                this.errors.ncomprobante = '';
            }
        },

        async agregarDetalle() {
            if (!this.validateFormAdd()) {
                this.$toast.error('Por favor complete correctamente los detalles del producto');
                return;
            }

            try {
                const selectedProduct = this.productos.find(p => p.id === this.detalle.productoId);

                // Manejo de productos con/sin variedad
                let variedadInfo = null;
                if (this.detalle.variedadId && selectedProduct.variedades) {
                    variedadInfo = selectedProduct.variedades.find(v => v.id === this.detalle.variedadId);
                }

                // Crear el nuevo detalle
                const nuevoDetalle = {
                    id: this.generateUniqueId(),
                    productoId: this.detalle.productoId,
                    productoNombre: selectedProduct.titulo,
                    variedadId: this.detalle.variedadId || null,
                    variedad: variedadInfo || null,
                    precio_unidad: parseFloat(this.detalle.precio_unidad),
                    cantidad: parseInt(this.detalle.cantidad),
                    subtotal: parseFloat(this.detalle.precio_unidad) * parseInt(this.detalle.cantidad)
                };

                console.log(nuevoDetalle)

                this.detalles.push(nuevoDetalle);

                localStorage.setItem('detallesPedido', JSON.stringify(this.detalles));

                this.detalle = {
                    productoId: '',
                    variedadId: '',
                    precio_unidad: 0,
                    cantidad: 1
                };

            } catch (error) {
                console.error('Error al agregar detalle:', error);
                this.$toast.error(error.response?.data?.message || 'Error al agregar el producto');
            }
        },

        generateUniqueId() {
            return Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
        },

        eliminarDetalle(id) {
            this.detalles = this.detalles.filter(detalle => detalle.id !== id);
            localStorage.setItem('detallesPedido', JSON.stringify(this.detalles));
        },

        validateFormAdd() {
            let isValid = true;

            if (!this.detalle.productoId) {
                this.errorAgregar.productoId = 'Seleccione un producto';
                isValid = false;
            } else {
                this.errorAgregar.productoId = '';
            }

            if (!this.detalle.precio_unidad) {
                this.errorAgregar.precio_unidad = 'Precio del producto es requerido';
                isValid = false;
            } else {
                this.errorAgregar.precio_unidad = '';
            }

            if (!this.detalle.cantidad) {
                this.errorAgregar.cantidad = 'Cantidad del producto es requerido';
                isValid = false;
            } else {
                this.errorAgregar.cantidad = '';
            }

            return isValid;
        },

        validateProducto() {
            if (!this.detalle.productoId) {
                this.errorAgregar.productoId = 'Seleccione un producto';
            } else {
                this.errorAgregar.productoId = '';
            }
        },

        validateCan() {
            if (!this.detalle.cantidad) {
                this.errorAgregar.cantidad = 'Cantidad del producto es requerido';
            } else {
                this.errorAgregar.cantidad = '';
            }
        },

        validatePrecio() {
            if (!this.detalle.precio_unidad) {
                this.errorAgregar.precio_unidad = 'Precio del producto es requerido';
            } else {
                this.errorAgregar.precio_unidad = '';
            }
        },

        selectProduct(event) {
            let productId = event.target.value;

            const selectedProduct = this.productos.find(product => product.id == productId);

            this.variedades = selectedProduct.variedades;
        }


    },
    computed: {
        calcularTotal() {
            return this.detalles.reduce((sum, d) => sum + parseFloat(d.subtotal), 0);
        }
    }
};
</script>
<style>
.is-invalid {
    border-color: #dc3545;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100vw;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(2px);
}

tfoot tr td {
    border-top: 2px solid #333 !important;
}
</style>